import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import UpwindCredentialsForm from "./UpwindCredentialsForm";
import UpwindConfigListing from "./UpwindConfigListing";

export default function UpwindPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={UpwindCredentialsForm}
      PullConfigListingView={UpwindConfigListing}
    />
  );
}